import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { BatteryTestsPage } from './pages/BatteryTestsPage.js';
import { BatteryModelsPage } from './pages/BatteryModelsPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { useAuth } from './hooks/useAuth.js';

export function App() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/battery-tests" element={<BatteryTestsPage />} />
        <Route path="/battery-models" element={<BatteryModelsPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}
